// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { endpoints } from "../api/endpoints";
import authAxios from "./_shared/authAxios";

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const playerIdentify = createAsyncThunk("deposit/identify", async ({ cnp, phone }, { rejectWithValue }) => {
  try {
    const response = await authAxios({
      url: endpoints.deposit.identify,
      method: "POST",
      data: { cnp },
    });

    if (response.data && response.data.error) {
      return rejectWithValue({ message: response.data.error });
    }

    return { data: response.data, success: true };
  } catch (err) {
    let errResp;
    if (err && err.response && err.response.data) {
      errResp = { error: err.response.data };
    } else {
      errResp = { error: err.toString() };
    }
    return rejectWithValue(errResp);
  }
});

export const doDeposit = createAsyncThunk(
  "deposit/doDeposit",
  async ({ customerId, grossAmount, bonusId, identify_result }, { rejectWithValue }) => {
    try {
      const response = await authAxios({
        url: endpoints.deposit.deposit,
        method: "POST",
        data: {
          customer_id: customerId.toString(),
          gross_amount: grossAmount,
          bonus_id: bonusId,
          identify_result: identify_result ? identify_result : { data: {}, success: false },
        },
      });
      if (response.data && response.data.status === 0) {
        return { data: response.data, success: true };
      }

      return rejectWithValue({
        message: response.data.message,
      });
    } catch (err) {
      let errResp;
      if (err && err.response && err.response.data) {
        errResp = { error: err.response.data };
      } else {
        errResp = { error: err.toString() };
      }
      return rejectWithValue(errResp);
    }
  }
);

export const depositSlice = createSlice({
  name: "deposit",
  initialState: {
    identifyInProgress: false,
    identifyResult: null,
    identifyError: null,
    depositInProgress: false,
    depositResult: null,
    depositError: null,
  },
  reducers: {
    resetDepositState: state => {
      state.identifyInProgress = false;
      state.identifyResult = null;
      state.identifyError = null;
      state.depositInProgress = false;
      state.depositResult = null;
      state.depositError = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(playerIdentify.fulfilled, (state, action) => {
        state.identifyInProgress = false;
        state.identifyResult = action.payload;
      })
      .addCase(playerIdentify.pending, state => {
        state.identifyInProgress = true;
        state.identifyResult = null;
        state.identifyError = null;
        state.depositInProgress = false;
        state.depositResult = null;
        state.depositError = null;
      })
      .addCase(playerIdentify.rejected, (state, action) => {
        state.identifyInProgress = false;
        state.identifyError = action.payload;
      })
      .addCase(doDeposit.fulfilled, (state, action) => {
        state.depositInProgress = false;
        state.depositResult = action.payload;
      })
      .addCase(doDeposit.pending, state => {
        state.depositInProgress = true;
        state.depositError = null;
      })
      .addCase(doDeposit.rejected, (state, action) => {
        state.depositInProgress = false;
        state.depositError = action.payload;
      });
  },
});

export const { resetDepositState } = depositSlice.actions;

export default depositSlice.reducer;
